import { render, staticRenderFns } from "./editInvoiceDialog.vue?vue&type=template&id=2558a3b6&"
import script from "./editInvoiceDialog.vue?vue&type=script&lang=js&"
export * from "./editInvoiceDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports